module.exports = __webpack_public_path__ + "static/media/global-compact.ec2a6134.png";